<template>
  <div class="doctor-detail-page">
    <div class="doctor-header">
      <div class="doctor-avatar">
        <img :src="doctor.avatar || defaultAvatar" alt="医生头像" />
      </div>
      <div class="doctor-info">
        <div class="doctor-name">{{ doctor.doctorName }} <span class="doctor-title">{{ doctor.title }}</span></div>
        <div class="doctor-tags" v-if="doctor.tags">
          <span class="tag" v-for="(tag, index) in parseTags(doctor.tags)" :key="index">{{ tag }}</span>
        </div>
      </div>
    </div>

    <div class="doctor-desc-wrapper">
      <div class="doctor-desc" :class="{ 'expand': isDescExpand }" ref="doctorDescRef">
        <p><strong>坐诊时间：</strong>{{ doctor.specialty || '暂无' }}</p>
        <p><strong>简介：</strong>{{ doctor.introduction || '暂无' }}</p>
      </div>
      <div class="desc-toggle" v-if="isDescOverflow" @click="toggleDescExpand">
        <van-icon :name="isDescExpand ? 'arrow-up' : 'arrow-down'" class="toggle-icon" />
        <span>{{ isDescExpand ? '收起' : '展开' }}</span>
      </div>
    </div>

    <div class="calendar-wrapper">
      <div class="calendar-title">门诊预约</div>
      <div class="calendar-weekdays">
        <span v-for="weekday in weekdays" :key="weekday">{{ weekday }}</span>
      </div>
      <div class="calendar-days">
        <div
          v-for="(day, index) in calendarDays"
          :key="index"
          class="calendar-day"
          :class="{
            'disabled': day.status === '未排班',
            'has-num': day.status === '有号',
            'no-release': day.status === '未放号',
            'full': day.status === '已满',
            'expired': day.status === '已过期',
            'selected': selectedDay && selectedDay.date === day.date
          }"
          @click="selectDay(day)"
        >
          <span class="day-num">{{ day.num }}</span>
          <span class="day-status">{{ day.status }}</span>
        </div>
      </div>
    </div>

    <div class="time-slots-wrapper" v-if="selectedDay && timeSlots.length > 0">
      <div class="slots-title">选择时间段</div>
      <div class="slots-grid">
        <div
          v-for="slot in timeSlots"
          :key="slot.slotId"
          class="slot-item"
          :class="{
            'disabled': slot.bookedNum >= slot.maxNum,
            'selected': selectedSlot && selectedSlot.slotId === slot.slotId
          }"
          @click="selectSlot(slot)"
        >
          <div class="slot-time">{{ formatTime(slot.startTime) }}-{{ formatTime(slot.endTime) }}</div>
          <div class="slot-remain">余{{ slot.maxNum - slot.bookedNum }}号</div>
        </div>
      </div>
    </div>

    <div class="book-info" v-if="selectedDay">
      <van-button color="#3e97c1" size="large" :loading="submitting" @click="handleBook">
        预约{{ selectedSlot ? '(余' + (selectedSlot.maxNum - selectedSlot.bookedNum) + ')' : '' }}
      </van-button>
    </div>

    <van-popup v-model="showConfirmPopup" position="bottom" round>
      <div class="confirm-popup">
        <div class="confirm-title">确认预约信息</div>
        <van-cell-group>
          <van-cell title="医生" :value="doctor.doctorName" />
          <van-cell title="科室" :value="doctor.department" />
          <van-cell title="日期" :value="selectedDay ? selectedDay.date : ''" />
          <van-cell title="时段" :value="selectedSlot ? formatTime(selectedSlot.startTime) + '-' + formatTime(selectedSlot.endTime) : ''" />
          <van-field v-model="patientForm.patientName" label="患者姓名" placeholder="请输入患者姓名" required />
          <van-field v-model="patientForm.patientPhone" label="手机号" placeholder="请输入手机号" type="tel" required />
          <van-field v-model="patientForm.patientIdCard" label="身份证号" placeholder="请输入身份证号（选填）" />
        </van-cell-group>
        <div class="confirm-actions">
          <van-button plain @click="showConfirmPopup = false">取消</van-button>
          <van-button type="primary" :loading="submitting" @click="confirmAppointment">确认预约</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'YuyueDetail',
  data() {
    return {
      doctorId: null,
      doctor: {},
      defaultAvatar: '',
      weekdays: ['一', '二', '三', '四', '五', '六', '日'],
      calendarDays: [],
      schedules: [],
      selectedDay: null,
      timeSlots: [],
      selectedSlot: null,
      isDescExpand: false,
      isDescOverflow: false,
      showConfirmPopup: false,
      submitting: false,
      patientForm: {
        patientName: '',
        patientPhone: '',
        patientIdCard: ''
      }
    }
  },
  created() {
    this.doctorId = this.$tool.getUrlParamByName('doctorId');
    if (this.doctorId) {
      this.loadDoctorInfo();
      this.loadSchedule();
    }

    var user = this.$tool.getUser();
    if (user) {
      this.patientForm.patientName = user.realName || '';
      this.patientForm.patientPhone = user.phone || '';
      this.patientForm.patientIdCard = user.idCard || '';
    }
  },
  mounted() {
    this.checkDescOverflow();
    window.addEventListener('resize', this.checkDescOverflow);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDescOverflow);
  },
  methods: {
    loadDoctorInfo() {
      this.$http.get(this.$Api.doctorInfo + '/' + this.doctorId)
        .then(res => {
          if (res.data.code === 200) {
            this.doctor = res.data.data;
          }
        });
    },
    loadSchedule() {
      this.$http.get(this.$Api.doctorSchedule + '/' + this.doctorId + '/schedule', {
        params: { weeks: 4 }
      }).then(res => {
        if (res.data.code === 200) {
          this.schedules = res.data.data.schedules || [];
          this.initCalendarDays();
        }
      });
    },
    initCalendarDays() {
      var days = [];
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var todayStr = this.formatDate(today);

      var dayOfWeek = today.getDay() || 7;
      var startDate = new Date(today);
      startDate.setDate(startDate.getDate() - (dayOfWeek - 1));

      for (var i = 0; i < 28; i++) {
        var currentDate = new Date(startDate);
        currentDate.setDate(startDate.getDate() + i);
        var dateStr = this.formatDate(currentDate);

        var isPast = dateStr < todayStr;

        var daySchedules = this.findSchedules(dateStr);
        var status = '未排班';
        var scheduleId = null;
        var totalRemain = 0;

        if (isPast) {
          status = '已过期';
        } else if (daySchedules.length > 0) {
          for (var j = 0; j < daySchedules.length; j++) {
            totalRemain += daySchedules[j].remainNum;
          }
          scheduleId = daySchedules[0].scheduleId;
          if (totalRemain > 0) {
            status = '有号';
          } else {
            status = '已满';
          }
        }

        days.push({
          date: dateStr,
          num: currentDate.getDate(),
          status: status,
          scheduleId: scheduleId,
          schedules: daySchedules,
          totalRemain: totalRemain,
          isToday: dateStr === todayStr,
          isPast: isPast
        });
      }
      this.calendarDays = days;
    },
    findSchedules(dateStr) {
      var result = [];
      for (var i = 0; i < this.schedules.length; i++) {
        var scheduleDate = this.schedules[i].scheduleDate;
        if (typeof scheduleDate === 'string' && scheduleDate.indexOf('T') > -1) {
          scheduleDate = scheduleDate.substring(0, 10);
        }
        if (scheduleDate === dateStr) {
          result.push(this.schedules[i]);
        }
      }
      return result;
    },
    findSchedule(dateStr) {
      var schedules = this.findSchedules(dateStr);
      return schedules.length > 0 ? schedules[0] : null;
    },
    formatDate(date) {
      var year = date.getFullYear();
      var month = (date.getMonth() + 1).toString();
      var day = date.getDate().toString();
      var monthStr = month.length === 1 ? '0' + month : month;
      var dayStr = day.length === 1 ? '0' + day : day;
      return year + '-' + monthStr + '-' + dayStr;
    },
    selectDay(day) {
      if (day.isPast || day.status === '未排班' || day.status === '已满' || day.status === '已过期') {
        return;
      }
      this.selectedDay = day;
      this.selectedSlot = null;
      this.loadAllTimeSlots(day.schedules);
    },
    loadAllTimeSlots(schedules) {
      this.timeSlots = [];
      var self = this;
      var promises = [];

      for (var i = 0; i < schedules.length; i++) {
        (function(schedule) {
          promises.push(
            self.$http.get(self.$Api.scheduleSlots + '/' + schedule.scheduleId + '/slots')
              .then(res => {
                if (res.data.code === 200) {
                  var slots = res.data.data || [];
                  for (var j = 0; j < slots.length; j++) {
                    slots[j].scheduleId = schedule.scheduleId;
                  }
                  return slots;
                }
                return [];
              })
          );
        })(schedules[i]);
      }

      Promise.all(promises).then(function(results) {
        var allSlots = [];
        for (var i = 0; i < results.length; i++) {
          allSlots = allSlots.concat(results[i]);
        }
        allSlots.sort(function(a, b) {
          return a.startTime.localeCompare(b.startTime);
        });

        if (self.selectedDay && self.selectedDay.isToday) {
          var now = new Date();
          var currentHour = now.getHours();
          var currentMinute = now.getMinutes();
          var currentTimeStr = (currentHour < 10 ? '0' : '') + currentHour + ':' + (currentMinute < 10 ? '0' : '') + currentMinute;

          allSlots = allSlots.filter(function(slot) {
            return slot.startTime > currentTimeStr;
          });
        }

        self.timeSlots = allSlots;
      });
    },
    selectSlot(slot) {
      if (slot.bookedNum >= slot.maxNum) {
        return;
      }
      this.selectedSlot = slot;
    },
    formatTime(time) {
      if (!time) return '';
      if (typeof time === 'string') {
        return time.substring(0, 5);
      }
      return time;
    },
    parseTags(tags) {
      if (!tags) return [];
      try {
        return JSON.parse(tags);
      } catch (e) {
        return tags.split(',');
      }
    },
    checkDescOverflow() {
      var descEl = this.$refs.doctorDescRef;
      if (!descEl) return;
      descEl.style.maxHeight = 'none';
      descEl.style.overflow = 'visible';
      var fourLineHeight = 89.6;
      var realHeight = descEl.offsetHeight;
      this.isDescOverflow = realHeight > fourLineHeight;
      if (this.isDescOverflow && !this.isDescExpand) {
        descEl.style.maxHeight = fourLineHeight + 'px';
        descEl.style.overflow = 'hidden';
      }
    },
    toggleDescExpand() {
      this.isDescExpand = !this.isDescExpand;
      var descEl = this.$refs.doctorDescRef;
      if (this.isDescExpand) {
        descEl.style.maxHeight = 'none';
        descEl.style.overflow = 'visible';
      } else {
        descEl.style.maxHeight = '89.6px';
        descEl.style.overflow = 'hidden';
      }
    },
    handleBook() {
      if (!this.selectedSlot) {
        this.$toast('请选择时间段');
        return;
      }

      var user = this.$tool.getUser();
      if (!user || !user.userId) {
        this.$toast.fail('请先登录');
        return;
      }

      this.showConfirmPopup = true;
    },
    confirmAppointment() {
      if (!this.patientForm.patientName.trim()) {
        this.$toast('请输入患者姓名');
        return;
      }
      if (!this.patientForm.patientPhone.trim()) {
        this.$toast('请输入手机号');
        return;
      }

      var user = this.$tool.getUser();
      var data = {
        userId: user.userId,
        doctorId: this.doctorId,
        scheduleId: this.selectedSlot.scheduleId,
        slotId: this.selectedSlot.slotId,
        appointmentDate: this.selectedDay.date,
        patientName: this.patientForm.patientName,
        patientPhone: this.patientForm.patientPhone,
        patientIdCard: this.patientForm.patientIdCard ? this.patientForm.patientIdCard.toUpperCase() : ''
      };

      this.submitting = true;
      this.$http.post(this.$Api.appointmentCreate, data)
        .then(res => {
          this.submitting = false;
          if (res.data.code === 200) {
            var userData = {
            userId: user.userId,
            openid: user.openid,
            isBind: true,
            realName: this.patientForm.patientName,
            phone: this.patientForm.patientPhone,
            idCard: this.patientForm.patientIdCard ? this.patientForm.patientIdCard.toUpperCase() : '',
            // 保留原有的头像和昵称信息
            nickname: user.nickname,
            headimgurl: user.headimgurl,
            authorizeTime: user.authorizeTime
          };
          this.$tool.setUser(userData);

            this.showConfirmPopup = false;
            this.$dialog.alert({
              title: '预约成功',
              message: '您已成功预约，请按时就诊'
            }).then(() => {
              this.$router.push('/mine/myAppointment');
            });
          } else {
            this.$toast.fail(res.data.msg || '预约失败');
          }
        })
        .catch(() => {
          this.submitting = false;
          this.$toast.fail('网络错误');
        });
    }
  }
}
</script>

<style scoped>
.doctor-detail-page {
  background: #f5f5f5;
  min-height: 100vh;
  font-size: 14px;
  padding-bottom: 80px;
}
.doctor-header {
  background: #3e97c1;
  color: #fff;
  padding: 16px;
  display: flex;
  align-items: center;
}
.doctor-avatar img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 16px;
  border: 2px solid rgba(255, 255, 255, 0.8);
}
.doctor-name {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 8px;
}
.doctor-title {
  font-size: 16px;
  font-weight: normal;
  margin-left: 8px;
  opacity: 0.9;
}
.doctor-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.tag {
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}
.doctor-desc-wrapper {
  color: white;
  background: #3e97c1;
  padding: 16px;
  margin-bottom: 8px;
}
.doctor-desc {
  line-height: 1.6;
  transition: max-height 0.3s ease;
}
.doctor-desc p {
  margin: 0 0 8px 0;
}
.doctor-desc p:last-child {
  margin-bottom: 0;
}
.desc-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  margin-top: 8px;
  cursor: pointer;
}
.toggle-icon {
  margin-right: 4px;
  transition: transform 0.3s ease;
}
.calendar-wrapper {
  background: #fff;
  padding: 16px;
  margin-bottom: 8px;
}
.calendar-title {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 16px;
  color: #333;
}
.calendar-weekdays {
  display: flex;
  justify-content: space-around;
  color: #666;
  margin-bottom: 12px;
  font-weight: 500;
}
.calendar-days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
}
.calendar-day {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}
.calendar-day.selected {
  background-color: #e8f4ff;
}
.calendar-day.disabled {
  color: #ccc;
  cursor: not-allowed;
}
.calendar-day.has-num {
  color: #3e97c1;
}
.calendar-day.no-release {
  color: #999;
}
.calendar-day.full {
  color: #999;
}
.calendar-day.expired {
  color: #ccc;
  cursor: not-allowed;
}
.calendar-day.expired .day-status {
  color: #ccc;
}
.day-num {
  font-size: 16px;
  font-weight: 500;
}
.day-status {
  font-size: 12px;
  margin-top: 4px;
}
.time-slots-wrapper {
  background: #fff;
  padding: 16px;
  margin-bottom: 8px;
}
.slots-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
  color: #333;
}
.slots-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.slot-item {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
}
.slot-item.selected {
  border-color: #3e97c1;
  background: #e8f4ff;
}
.slot-item.disabled {
  background: #f5f5f5;
  color: #999;
  cursor: not-allowed;
}
.slot-time {
  font-size: 14px;
  font-weight: 500;
}
.slot-remain {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.slot-item.selected .slot-remain {
  color: #3e97c1;
}
.book-info {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  padding: 16px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}
.confirm-popup {
  padding: 16px;
}
.confirm-title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 16px;
}
.confirm-actions {
  display: flex;
  gap: 10px;
  margin-top: 16px;
}
.confirm-actions .van-button {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/yuyue/detail.vue